export const SlbServicesPdpPageTemplate = {
    slots: ['SlbServicesPdpContainerSlot', 'SlbBlueBottomBannerSlot'],
  };
  